import { VFC } from "react";

import { usePartnersSliceSelector } from "../store/partnersStore";
import { useSetState } from "../store/smc3IntegrationsSlice";
import CarrierIntegrationsFilterBarView from "../views/CarrierIntegrationsFilterBarView";

const CarrierIntegrationsFilterBarContainer: VFC = () => {
  const search = usePartnersSliceSelector((state) => state.smc3IntegrationsSlice.search);
  const setState = useSetState();

  return <CarrierIntegrationsFilterBarView search={search} setSearch={(search) => setState({ search })} />;
};

export default CarrierIntegrationsFilterBarContainer;
